import React from 'react'
import CEOMessage from './AboutUs/components/CEOMessage/CEOMessage'
import ContactCards from './Contact/components/ContactCards/ContactCards'
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import './Home.css'
import HeroSection from '../components/HeroSection/HeroSection'
import PropertyCarousel from '../components/PropertyCarousel/PropertyCarousel';
import Consultancy from '../components/Consultancy/Consultancy';
import ExploreProperties from '../components/ExploreProperties/ExploreProperties';
import PropertiesLinks from '../components/PropertiesLinks/PropertiesLinks';

// Variants for section animation
const sectionVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

export default function Home() {

  return (
    <>
      <Helmet>
        <title>Home</title>
        <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
      </Helmet>

      <div className='home-container'>
        <HeroSection/>

        <motion.div variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
    <PropertyCarousel pageTitle="Ongoing Projects" filterType="ongoing" />
        </motion.div>

        <motion.div variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
         <Consultancy />
        </motion.div>


        <motion.div variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <PropertiesLinks />
        </motion.div>

        <motion.div variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <CEOMessage />
        </motion.div>


        <motion.div variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} transition={{ delay: 0.3 }}>
          <ContactCards />
        </motion.div>

        <motion.div variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} transition={{ delay: 0.3 }}>
          <ExploreProperties />
        </motion.div>
      </div>
    </>
  )
}
